/**
 * Whether a pack names a FIELD, or deliberately names none.
 *
 * The three product verticals each stand for a career area, and the preview's chrome leans on that in
 * several places: it offers "one thing people in this job actually do", and it promises "two real
 * career paths" and "where that takes you in Finance". Every one of those sentences is true of finance,
 * consulting and data, and false of Career Explorer, which exists precisely because it goes on pages
 * about nursing and marketing and engineering at once.
 *
 * Left as false and the copy does not merely read oddly. It quietly tells a reader that the lab is
 * about the field they were reading about, which is the one claim this pack must never make.
 *
 * 🔴 A SLUG CHECK, ON PURPOSE, RATHER THAN A FIELD ON `VerticalPack`. One pack differing in three
 * strings does not justify a contract change that every future pack has to answer, and a boolean on the
 * pack would invite exactly the wrong follow-up: branching CONTENT on it rather than chrome. If a
 * second field-less pack ever exists, promote this to a real property then, with a real reason.
 */

/** The one pack that names no field. */
export const FIELD_LESS_SLUG = 'explore';

export function isFieldLessPack(slug: string): boolean {
  return slug === FIELD_LESS_SLUG;
}
